import React from 'react';
import ChatPreview from './ChatPreview';
import { resolveAgentIdentityText } from '../utils/chatWidgetConfig';

/** Purpose: render the live embeddable chat experience. Why: the widget owns its visitor/session messaging UI independently from the admin preview. */
export default function ChatWidgetView({
  widgetConfig = {},
  messages = [],
  loading = false,

  inputValue = '',
  onInputChange = () => {},
  onSend = () => {},

  quickReplies = [],
  onQuickReply = () => {},

  onReset = () => {},
  onHome = () => {},
  onClose = null,
  onAttachment = null,

  inputControl = null,

  footerHint = '',
}) {
  const resolvedWidgetConfig = {
    title: widgetConfig.title || 'Bot Preview',

    subtitle:
      widgetConfig.subtitle ||
      'Live bot testing',

    statusText:
      widgetConfig.statusText ||
      'Online',

    agentIdentity: resolveAgentIdentityText(widgetConfig.agentIdentityMode, widgetConfig.agentIdentityLabel, 'Lucky'),

    avatarText:
      widgetConfig.avatarText ||
      'VB',

    avatarUrl:
      widgetConfig.avatarUrl ||
      '',

    showHeader:
      widgetConfig.showHeader !== false,

    showAvatar:
      widgetConfig.showAvatar !== false,

    showTitle:
      widgetConfig.showTitle !== false,

    showSubtitle:
      widgetConfig.showSubtitle !== false,

    showStatus:
      widgetConfig.showStatus !== false,

    showReset:
      widgetConfig.showReset !== false,

    showHome:
      widgetConfig.showHome !== false,

    resetLabel:
      widgetConfig.resetLabel ||
      'Reset',

    inputPlaceholder:
      widgetConfig.inputPlaceholder ||
      'Type your message...',

    themeMode:
      widgetConfig.themeMode ||
      'light',

    primaryColor:
      widgetConfig.primaryColor ||
      '#d95b0a',

    secondaryColor:
      widgetConfig.secondaryColor ||
      '#f26a00',

    accentColor:
      widgetConfig.accentColor ||
      '#f26a00',

    complementaryColor:
      widgetConfig.complementaryColor ||
      '#15588a',

    brandColorMode:
      widgetConfig.brandColorMode ||
      'gradient',

    fontStyle:
      widgetConfig.fontStyle ||
      'default',

    fontFamily:
      widgetConfig.fontFamily ||
      'inherit',

    fontSize:
      widgetConfig.fontSize ||
      'medium',

    textSize:
      widgetConfig.textSize ||
      14,

    textColor:
      widgetConfig.textColor ||
      '',
  };

  return (
    <ChatPreview
      title={resolvedWidgetConfig.title}

      subtitle={
        resolvedWidgetConfig.subtitle
      }

      botName={
        resolvedWidgetConfig.title
      }

      status={
        loading
          ? 'Typing...'
          : resolvedWidgetConfig.statusText
      }

      agentIdentity={resolvedWidgetConfig.agentIdentity}

      avatarText={
        resolvedWidgetConfig.avatarText
      }

      avatarUrl={
        resolvedWidgetConfig.avatarUrl
      }

      showHeader={
        resolvedWidgetConfig.showHeader
      }

      showAvatar={
        resolvedWidgetConfig.showAvatar
      }

      showTitle={
        resolvedWidgetConfig.showTitle
      }

      showSubtitle={
        resolvedWidgetConfig.showSubtitle
      }

      showStatus={
        resolvedWidgetConfig.showStatus
      }

      showReset={
        resolvedWidgetConfig.showReset
      }

      showHome={
        resolvedWidgetConfig.showHome
      }

      showWatermark={
        resolvedWidgetConfig.showWatermark
      }

      resetLabel={
        resolvedWidgetConfig.resetLabel
      }

      messages={messages}

      typing={loading}

      inputValue={inputValue}

      onInputChange={
        onInputChange
      }

      onSend={
        onSend
      }

      quickReplies={
        quickReplies
      }

      onQuickReply={
        onQuickReply
      }

      onReset={
        onReset
      }

      onHome={
        onHome
      }

      onClose={
        onClose
      }

      onAttachment={
        onAttachment
      }

      inputType={
        inputControl?.inputType ||
        'text'
      }

      dateValidation={
        inputControl?.dateValidation ||
        {}
      }

      placeholder={
        inputControl?.placeholder ||
        resolvedWidgetConfig.inputPlaceholder
      }

      footerHint={
        footerHint
      }

      themeMode={
        resolvedWidgetConfig.themeMode
      }

      primaryColor={
        resolvedWidgetConfig.primaryColor
      }

      accentColor={
        resolvedWidgetConfig.brandColorMode ===
        'gradient'
          ? resolvedWidgetConfig.secondaryColor
          : resolvedWidgetConfig.accentColor
      }

      complementaryColor={
        resolvedWidgetConfig.complementaryColor
      }

      fontFamily={
        resolvedWidgetConfig.fontFamily
      }

      fontSize={
        resolvedWidgetConfig.fontSize
      }

      textSize={
        resolvedWidgetConfig.textSize
      }

      textColor={
        resolvedWidgetConfig.textColor
      }
    />
  );
}
